export default "__VITE_ASSET__4NDFjBiL__"